<div class="grid-x history-bar review-content">
  <div class="cell small-8 bold event">{{item?.eventDescription}}</div>
  <div class="cell small-4 event">{{item?.fullDate | date: 'short'}}</div>
  @switch (item?.level) {
    @case ('action') {
      <div class="user grid-x">
        <div class="cell small-12">User: {{item?.userName}} | {{item?.organization}}</div>
        <div class="cell small-6"> Status: {{item?.status}}</div>
        <div class="cell small-6"> Type: {{getHistoryItemType()}}</div>
      </div>
    }
    @default {
      <div class="user grid-x">
        @if (item && item.assignedTo != '') {
          <div class="cell small-12">Assigned To: {{item?.assignedTo}}</div>
        }
        @if (item && item.groupName != '') {
          <div class="cell small-12">Assigned Group: {{item?.groupName}}</div>
        }
        <div class="cell small-6"> Status: {{item?.status}}</div>
        <div class="cell small-6"> Type: {{getHistoryItemType()}}</div>
      </div>
    }
  }
</div>
